<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Performance Inputs</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (airflowSelection) {
          <span class="configurationInput">
            <span class="configurationInputLabel">Airflow:</span>
            <input
              type="number"
              class="configurationRatingTextInput"
              #airflowInput
              [value]="airflowSelection.Value"
              (change)="selectionChanged(airflowSelection, airflowInput.value || '0')" />
            <span class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits() }}</span>
          </span>
        }
        @if (staticPressureTypeSelection && staticPressureValueSelection) {
          <span class="configurationInput">
            <select class="staticPressureInputField configurationInputField" #staticPressureTypeInput
              (change)="selectionChanged(staticPressureTypeSelection, staticPressureTypeInput.value.toString())"
              [value]="staticPressureTypeSelection.Value">
              @for (allowable of staticPressureTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                            [selected]="staticPressureTypeSelection?.Value?.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
            <input type="number" class="configurationRatingTextInput" #staticPressureValueInput
              [value]="staticPressureValueSelection.Value" step="0.01"
              (change)="selectionChanged(staticPressureValueSelection, staticPressureValueInput.value || '0')">
            <span class="configurationRatingUnitLabel">{{ getPressureMeasurementUnits() }}</span>
          </span>
        }
        @if (altitudeSelection) {
          <span class="configurationInput">
            <span class="configurationInputLabel">Altitude:</span>
            <input
              type="number"
              class="configurationRatingTextInput"
              #altitudeInput
              [value]="altitudeSelection.Value"
              (change)="selectionChanged(altitudeSelection, altitudeInput.value)" />
            <span class="configurationRatingUnitLabel">{{ getDistanceMeasurementUnits() }}</span>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (inputTypeSelection) {
          <span class="configurationInput">
            <span class="configurationInputLabel">Input Type:</span>
            <select
              class="configurationInputField"
              #inputTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(inputTypeSelection.Name)"
              (change)="inputTypeChanged(inputTypeInput.value)"
              [value]="inputTypeSelection.Value">
              @for (allowable of inputTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="inputTypeSelection.Value !== undefined && inputTypeSelection.Value !== null && inputTypeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      <app-performance-input
        [engineKey]="engineKey()"
        [selectionEntities]="selectionEntities()"
        [isMetric]="isMetric"
        (valueChanged)="performanceValueChanged()"></app-performance-input>
      @if (ratingResponseError) {
        <div class="ratingError">
          {{ ratingResponseError }}
        </div>
      }
    </div>
  }
</div>
